import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MenuItemState } from './menuItem.types';
import { MenuItem, CookingIngredient } from '../../models/menuItem';

const initialState: MenuItemState = {
  menuItemPath: null,
  menuItem: null,
  cookingIngredients: [],
  loading: false,
  error: null
};

const menuItemSlice = createSlice({
  name: 'menuItem',
  initialState,
  reducers: {
    setMenuItemPath: (state, action: PayloadAction<string>) => {
      console.log("SET MENU ITEM PATH");
      state.menuItemPath = action.payload;
    },
    menuItemUpdated: (state, action: PayloadAction<MenuItem>) => {
          state.menuItem = action.payload;
          state.loading = false;
          state.error = null;
        },
    menuItemListenerError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    menuItemCookingIngredientsUpdated: (state, action: PayloadAction<{
      cookingIngredients: CookingIngredient[],
      menuItemPath: string
    }>) => {
      if(state.menuItemPath === action.payload.menuItemPath){
        state.cookingIngredients = action.payload.cookingIngredients;
      }
    },
    resetMenuItem: (state) => {
      state.menuItemPath = null;
      state.menuItem = null;
      state.cookingIngredients = [];
      state.loading = false;
      state.error = null;
    }
  }
});

export const {
  setMenuItemPath,
  resetMenuItem,
  menuItemUpdated,
  menuItemListenerError,
  menuItemCookingIngredientsUpdated,
} = menuItemSlice.actions;

export default menuItemSlice.reducer;
